<template>
  <div class="wrapper">
    <h3>youtube</h3>

    <!-- youtube play controller -->
    <div>
      <el-slider v-model="seekValue" :max="duration" :format-tooltip="timeFormat" />
      <div>{{timeFormat(seekValue)}} / {{timeFormat(duration)}}</div>

      <el-button @click="playVideo">play</el-button>
      <el-button @click="pauseVideo">pause</el-button>
    </div>

    <!-- youtube player visible -->
    <div>
      <el-button :disabled="visible" @click="showPlayer">show</el-button>
      <el-button :disabled="!visible" @click="hidePlayer">hide</el-button>
    </div>

    <label>url</label><el-input v-model="input_url" />
    <el-button @click="setYoutubeUrl" >set url</el-button>
  </div>
</template>

<script lang="">
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      input_url : '',
      seekValue : 0,
      duration  : 0
    }
  },
  computed: {
    ...mapGetters('video/youtube', [
      'player',
      'visible'
    ])
  },
  methods: {
    playVideo () {
      this.player.playVideo()
    },
    pauseVideo () {
      this.player.pauseVideo()
    },
    setYoutubeUrl () {
      if (this.input_url.indexOf('https://') === 0) {
        this.player.loadVideoById(this.$youtube.getIdFromUrl(this.input_url))
      }
    },
    timeFormat (value) {
      const h = Math.floor(value / 3600)
      const m = '0' + Math.floor(value / 60) % 60
      const s = '0' + Math.floor(value % 60) % 60
      return `${h}:${m.slice(-2)}:${s.slice(-2)}`
    },
    ...mapMutations('video/youtube', [
      'hidePlayer',
      'showPlayer'
    ])
  },
  watch: {
    seekValue (value) {
      if (Math.abs(this.player.getCurrentTime() - value) >= 1) {
        this.player.seekTo(value, true)
      }
    }
  },
  mounted () {
    setInterval(() => {
      if (!this.player) return
      if (this.player.getDuration() !== this.duration) this.duration =  this.player.getDuration()
      this.seekValue = this.player.getCurrentTime()
    }, 1000)
  }
}
</script>

<style scoped>
.wrapper {
  background-color : silver;
  width            : 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/video/controller/youtube-controller.vue